import type { CSSProperties } from 'react';

import checklistUrl from '../../assets/icons/vivicta-icons-checklist.svg';
import cloudUrl from '../../assets/icons/vivicta-icons-cloud.svg';
import cogwheelUrl from '../../assets/icons/vivicta-icons-cogwheel.svg';
import dataUrl from '../../assets/icons/vivicta-icons-data-a.svg';
import hubUrl from '../../assets/icons/vivicta-icons-hub.svg';
import lightbulbUrl from '../../assets/icons/vivicta-icons-lightbulb-a.svg';
import monitorUrl from '../../assets/icons/vivicta-icons-monitor.svg';
import protectedUrl from '../../assets/icons/vivicta-icons-protected.svg';
import stepsUrl from '../../assets/icons/vivicta-icons-steps.svg';
import { cn } from '../../lib/utils';

const BRAND_ICON_URLS = {
  checklist: checklistUrl,
  cloud: cloudUrl,
  cogwheel: cogwheelUrl,
  data: dataUrl,
  hub: hubUrl,
  lightbulb: lightbulbUrl,
  monitor: monitorUrl,
  protected: protectedUrl,
  steps: stepsUrl,
} as const;

export type BrandIconName = keyof typeof BRAND_ICON_URLS;

type BrandIconProps = {
  name: BrandIconName;
  className?: string;
};

/**
 * An icon from the Vivicta icon pack. The SVG is used as a mask, so the glyph
 * takes the current text colour and follows the light and dark themes.
 */
export const BrandIcon = ({ name, className }: BrandIconProps) => {
  const mask = `url(${BRAND_ICON_URLS[name]}) center / contain no-repeat`;
  const style: CSSProperties = { mask, WebkitMask: mask };
  return (
    <span
      aria-hidden="true"
      data-brand-icon={name}
      className={cn('inline-block size-5 shrink-0 bg-current', className)}
      style={style}
    />
  );
};
